import ApiClient from "@common/api/ApiClient";

class Observations extends ApiClient {
  constructor() {
    super("Observation");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async () => {
    return await this.get("Create");
  };

  Create = async (payload) => {
    return await this.post(`Create`, payload);
  };

  ReadForUpdate = async (id) =>
    await this.get(`Update?id=${id}&includeImages=true&includeThumbnails=true`);

  Read = async (id) => {
    const record = await this.get(
      `Read?id=${id}&includeImages=true&includeThumbnails=true`,
    );
    return { record };
  };

  Update = async (payload) => await this.post(`Update`, payload);
}

const client = new Observations();

export default client;
